import { get, startsWith } from 'lodash';

const siteprefixDefault = (href: string): string => href;
const getPublicConfig: (module: string) => object = get(window, 'skeletonPwa.container.getPublicConfig', () => ({}));

// Site prefix configured for deployment
export const { siteprefix }: { siteprefix: typeof siteprefixDefault } = get(window, 'skeletonPwa.container') || {
  siteprefix: siteprefixDefault,
};

const siteHost =
  window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

export const getFullHref = (href: string) =>
  startsWith(href, 'http') || startsWith(href, 'www') ? href : siteHost + siteprefix(href);

export const getConfig: (configPath: string, defaultValue?: any) => any = (configPath, defaultValue = null) =>
  get(get(window as any, 'datashop.app.config', () => ({}))(), configPath, defaultValue);

export const getPatientConfig: (configPath: string, defaultValue?: any) => any = (configPath, defaultValue = null) =>
  get(getPublicConfig('patient'), configPath, defaultValue);
